import type {DocumentDetails} from "types/documentData";

/** the id the user knows the document by, or the internal one when it has none */
export const getDisplayId = (details: DocumentDetails) => details.displayId || details.documentId;

/** the branch by name, or by its code when it has no name */
export const getBranchName = (details: DocumentDetails) => details.branch?.name || details.branch?.branchCd;
